interface IProductInfo {
  variant: GQL.IProductVariant;
  quantity: number;
  size: string | undefined;
}

export default (products: IProductInfo[], currency: any, vatRate = 0) => {
    return products.reduce((sum: number, product: IProductInfo) => {
      if (product.variant && product.variant.prices && currency) {
        const pvp = product.variant.prices.find((p: GQL.IPrice) => p.currencyId && p.currencyId === currency.id);
        if (pvp && pvp.tariffFee) {
          return sum + (pvp.tariffFee / 100 * (100 + vatRate) * product.quantity);
        }
      }
      return sum;
    }, 0);
};


// WEBPACK FOOTER //
// ./src/helpers/orders/getTotalTariffFee.ts